import { Icon } from 'common/icon';

import { Button } from './styles';
import { IconButtonProps } from './types';

export const IconButton = (props: IconButtonProps) => {
  const { icon, disabled, iconColor = 'white', onClick } = props;

  return (
    <Button
      type="button"
      onClick={onClick}
      disabled={disabled}
      iconColor={iconColor}
    >
      <Icon icon={icon || ''} />
    </Button>
  );
};
